module.exports = __webpack_public_path__ + "img/lumilive_1.251a49c2.png";